import MicroModal from 'micromodal';

export default class Inquiry {
    static readonly SENT_MODAL_ID = 'inquiry-sent-modal';

    static init(): void {
        this.handleSentModal();

        const sections: NodeListOf<HTMLElement> = document.querySelectorAll('.inquiry-section');

        if (sections.length > 0) {
            sections.forEach((section) => {
                const links: NodeListOf<HTMLElement> = section.querySelectorAll('[data-inquiry-link]');
                const contents: NodeListOf<HTMLElement> = section.querySelectorAll('[data-inquiry-content]');
                const switchButtons: NodeListOf<HTMLElement> = section.querySelectorAll('.js-inquiry-switch-button');

                let isAnimating = false;

                const showContent = (step: string): void => {
                    contents.forEach((content) => {
                        content.classList.toggle('is-active', content.dataset.inquiryContent === step);
                    });
                };

                const setStep = (step: string): void => {
                    const current: HTMLElement | null = section.querySelector('[data-inquiry-content].is-active');

                    if (isAnimating || current?.dataset.inquiryContent === step) {
                        return;
                    }

                    links.forEach((link) => {
                        link.classList.toggle('is-active', link.dataset.inquiryLink === step);
                    });

                    if (!current) {
                        showContent(step);
                        return;
                    }

                    // fade out current step, then fade in the new one
                    isAnimating = true;
                    current.classList.add('is-leaving');
                    const onFadeOut = (event: AnimationEvent): void => {
                        // ignore animations bubbling from nested elements
                        if (event.target !== current) {
                            return;
                        }

                        current.removeEventListener('animationend', onFadeOut);
                        current.classList.remove('is-leaving');
                        showContent(step);
                        isAnimating = false;
                    };

                    current.addEventListener('animationend', onFadeOut);
                };

                // switch is clickable only when not disabled (step 2 is informative only)
                links.forEach((link) => {
                    link.addEventListener('click', (event) => {
                        event.preventDefault();

                        if (!link.classList.contains('inquiry-switcher__item--disabled') && link.dataset.inquiryLink) {
                            setStep(link.dataset.inquiryLink);
                        }
                    });
                });

                switchButtons.forEach((button) => {
                    button.addEventListener('click', (event) => {
                        event.preventDefault();
                        setStep('2');
                    });
                });
            });
        }
    }

    // po odeslání (Naja překreslí snippet s .inquiry-sent) nebo po redirectu
    // s flash zprávou (bez JS odeslání) se otevře potvrzovací popup
    static handleSentModal(): void {
        if (!document.getElementById(this.SENT_MODAL_ID)) {
            return;
        }

        const openIfSent = (root: ParentNode): void => {
            if (root.querySelector('.inquiry-sent')) {
                MicroModal.show(this.SENT_MODAL_ID, {
                    disableScroll: true,
                    awaitOpenAnimation: true,
                    awaitCloseAnimation: true,
                });
            }
        };

        openIfSent(document);

        _naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            openIfSent(event.detail.snippet);
        });
    }
}
